import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'rl-list-edit-legacy-renav',
  template: '',
})
export class ListEditLegacyRenavComponent implements OnInit {
  constructor(private activatedRoute: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    const paramMap = this.activatedRoute.snapshot.paramMap;

    const version = paramMap.get('version');
    const tenantCode = paramMap.get('tenantCode');
    const listId = paramMap.get('listId');

    const listIdDotHtml = `${listId}.html`;

    this.router.navigate([version, tenantCode, 'lists', listIdDotHtml], {
      replaceUrl: true,
      preserveFragment: true,
      queryParamsHandling: 'preserve',
    });
  }
}
